import { PaymentOperationListItem } from '@/models/dictionary/payment-operation-list.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { defineStore } from 'pinia';

interface PaymentOperationListState {
  paymentOperationList: PaymentOperationListItem[];
  isPaymentOperationListLoading: boolean;
}

export const usePaymentOperationListStore = defineStore({
  id: 'PaymentOperationListStore',
  state: (): PaymentOperationListState => ({
    paymentOperationList: [],
    isPaymentOperationListLoading: false,
  }),
  actions: {
    setPaymentOperationListLoading(isLoading: boolean): void {
      this.isPaymentOperationListLoading = isLoading;
    },
    getPaymentOperationList(): Promise<PaymentOperationListItem[] | void> {
      if (this.paymentOperationList.length > 0) {
        return Promise.resolve(this.paymentOperationList);
      }

      this.setPaymentOperationListLoading(true);

      return api.dictionary.getPaymentOperationListRequest.perform()
        .then((data) => {
          this.paymentOperationList = data;
        })
        .catch(error => {
          showErrorNotification(error);

          return Promise.reject(error);
        })
        .finally(() => {
          this.setPaymentOperationListLoading(false);
        });
    },
  },
});
